import * as React from "react";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers";
import { isSameWeek } from "date-fns";
import { DateTime } from "luxon";

export function makeRenderWeekDay(
  hoveredDate: DateTime<true> | DateTime<false> | null,
  setHoveredDate: (date: DateTime<true> | DateTime<false> | null) => void,
  toJsDate: (value: DateTime<true> | DateTime<false>) => Date
): React.FC<PickersDayProps<DateTime<true> | DateTime<false>>> {
  const RenderWeekDay: React.FC<
    PickersDayProps<DateTime<true> | DateTime<false>>
  > = (props) => {
    const { day } = props;

    // Convert both hovered and day to JS Dates safely
    const jsDay = toJsDate(day);
    const jsHovered = hoveredDate ? toJsDate(hoveredDate) : null;

    const isHoveredWeek =
      jsHovered != null && isSameWeek(jsDay, jsHovered, { weekStartsOn: 1 });

    return (
      <PickersDay
        {...props}
        onMouseEnter={() => setHoveredDate(day)}
        onMouseLeave={() => setHoveredDate(null)}
        sx={{
          ...(isHoveredWeek && {
            backgroundColor: "#e0f7fa",
            borderRadius: "50%",
            "&:hover": {
              backgroundColor: "#b2ebf2",
            },
          }),
          ...props.sx,
        }}
      />
    );
  };

  return RenderWeekDay;
}
